import { reactive } from 'vue';
import { supabase } from '../supabase';

const cstore = reactive({
  secData: [],
  courseData: [],
  refresh: fetchCourseData,
  searchData: []
});

async function fetchData() {
  const { data, error } = await supabase.from('course').select('*').order('id', { ascending: true });

  if (error) {
    console.error(error);
    return;
  }

  cstore.secData = data;
}


async function fetchCourseData() {
  // const { data, error } = await supabase
  //   .from('course')
  //   .select(`
  //   id,
  //   title,
  //   price,
  //   short_desc,
  //   description,
  //   skills,
  //   lesson (
  //     id,
  //     name,
  //     lesson_type,
  //     lesson_desc,
  //     section (
  //       id,
  //       display_order,
  //       type,
  //       content
  //     ),
  //     exercise(*)
  //   )
  // `)
  //   .order('display_order', {
  //     foreignTable: 'lesson.section',
  //     ascending: true,
  //   });

  const { data, error } = await supabase
    .from('course')
    .select(`
    id,
    title,
    price,
    short_desc,
    description,
    skills,
    lesson (
      id,
      name,
      lesson_order,
      lesson_type,
      lesson_desc,
      section (
        id,
        display_order,
        type,
        content
      ),
      exercise(*)
    )
  `)
    .order('lesson_order', {
      foreignTable: 'lesson',
      ascending: true,
    })
    .order('display_order', {
      foreignTable: 'lesson.section',
      ascending: true,
    });

  if (error) {
    console.error(error);
    return;
  }

  cstore.courseData = data;
}


async function fetchSearchData() {
  const { data } = await supabase.from('v_search_suggestions').select(`*`)
  cstore.searchData = data;


}

fetchData();

fetchCourseData();

fetchSearchData();

export default cstore;